import React, { useCallback, useState } from 'react';
import { View, } from 'react-native';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { rem } from 'design-system';
import { isWeb } from '../../../../../constants';
export const LABEL_HEIGHT = rem(18); // Text-12 line height
export const Label = React.memo(({ text }) => {
    const colors = useColors();
    return (<View style={styles.container}>
      <Text Text-12 numberOfLines={1} centered color={colors.text.tertiary}>
        {text}
      </Text>
    </View>);
});
Label.displayName = 'Label';
const MARGIN = rem(8);
function clamp(value, min, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
}
export const PositionedLabel = React.memo(({ text, position, containerWidth }) => {
    const colors = useColors();
    const [offset, setOffset] = useState(0);
    const place = useCallback((width) => {
        const min = MARGIN;
        const max = containerWidth - MARGIN - width;
        setOffset(clamp(containerWidth * position - width / 2, min, max));
    }, [containerWidth, position]);
    const onTextLayout = useCallback((event) => {
        if (event.nativeEvent.lines.length === 0)
            return;
        place(event.nativeEvent.lines[0].width);
    }, [place]);
    // react-native-web never calls onTextLayout, so on web measure the wrapper
    const onLayout = useCallback((event) => place(event.nativeEvent.layout.width), [place]);
    // Moved with translateX, not left: changing left changes the width the
    // text is measured in, and on Android the new width moves it back again.
    return (<View onLayout={isWeb ? onLayout : undefined} style={[styles.absolute, { transform: [{ translateX: offset }] }]}>
        <Text Text-12 color={colors.text.tertiary} numberOfLines={1} onTextLayout={onTextLayout}>
          {text}
        </Text>
      </View>);
});
PositionedLabel.displayName = 'PositionedLabel';
const styles = {
    container: {
        paddingVertical: rem(4),
    },
    absolute: {
        position: 'absolute',
        left: 0,
    },
};
